export default {
  FontFamily: [
    '"Lato"',
    '"Helvetica Neue"',
    'sans-serif'
  ].join(',')
};